import React from "react";
import MainCard from "../../../../../components/MainCard";
import { Button, Box, Typography, Grid, Avatar, Stack } from "@mui/material";
import { useNavigate } from "react-router";
import { JobSeeker } from "../../../../../types/resumes-managment/jobSeeker";

const ViewPersonalInformation = ({
  personalInfo,
}: {
  personalInfo: JobSeeker;
}) => {
  const navigate = useNavigate();

  return (
    <MainCard
      title="Personal Information"
      headerActions={
        <Button
          variant="contained"
          color="primary"
          onClick={() =>
            navigate(`/jobseekers/edit-jobseeker/${personalInfo?.id}`)
          }
        >
          Edit Personal Information
        </Button>
      }
    >
      <Grid container>
        <Grid item md={4} xs={12}>
          <Avatar
            src={personalInfo?.image || ""}
            alt={personalInfo?.full_name || "User"}
            sx={{
              width: 200,
              height: 200,
              border: "2px solid #E9E9E9",
              objectFit: "contain",
            }}
          />
        </Grid>
        <Grid
          item
          md={4}
          xs={12}
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
            justifyContent: "center",
          }}
        >
          {personalInfo?.full_name && (
            <Box sx={{ display: "flex", gap: "1rem", width: "100%" }}>
              <Typography color="GrayText" sx={{ width: "30%" }}>
                Full Name (English):
              </Typography>
              <Typography sx={{ width: "70%" }}>
                {personalInfo.full_name}
              </Typography>
            </Box>
          )}
          {personalInfo?.full_name_arabic && (
            <Box sx={{ display: "flex", gap: "1rem", width: "100%" }}>
              <Typography color="GrayText" sx={{ width: "30%" }}>
                Full Name (Arabic):
              </Typography>
              <Typography sx={{ width: "70%" }}>
                {personalInfo?.full_name_arabic?.ar}
              </Typography>
            </Box>
          )}
          {personalInfo?.birthdate && (
            <Box sx={{ display: "flex", gap: "1rem", width: "100%" }}>
              <Typography color="GrayText" sx={{ width: "30%" }}>
                Birthdate:
              </Typography>
              <Typography sx={{ width: "70%" }}>
                {personalInfo.birthdate}
              </Typography>
            </Box>
          )}
          {personalInfo?.gender && (
            <Box sx={{ display: "flex", gap: "1rem", width: "100%" }}>
              <Typography color="GrayText" sx={{ width: "30%" }}>
                Gender:
              </Typography>
              <Typography sx={{ width: "70%" }}>
                {personalInfo.gender === "MALE" ? "Male" : "Female"}
              </Typography>
            </Box>
          )}
        </Grid>
        <Grid
          item
          md={4}
          xs={12}
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
            justifyContent: "center",
          }}
        >
          {personalInfo?.title_name && (
            <Box sx={{ display: "flex", gap: "1rem", width: "100%" }}>
              <Typography color="GrayText" sx={{ width: "30%" }}>
                Title:
              </Typography>
              <Typography sx={{ width: "70%" }}>
                {personalInfo?.title_name}
              </Typography>
            </Box>
          )}
          {personalInfo?.country_name && (
            <Box sx={{ display: "flex", gap: "1rem", width: "100%" }}>
              <Typography color="GrayText" sx={{ width: "30%" }}>
                Country:
              </Typography>
              <Typography sx={{ width: "70%" }}>
                {personalInfo?.country_name}
              </Typography>
            </Box>
          )}
          {personalInfo?.city_name && (
            <Box sx={{ display: "flex", gap: "1rem", width: "100%" }}>
              <Typography color="GrayText" sx={{ width: "30%" }}>
                City:
              </Typography>
              <Typography sx={{ width: "70%" }}>
                {personalInfo?.city_name}
              </Typography>
            </Box>
          )}
          {personalInfo?.nationality?.name && (
            <Box sx={{ display: "flex", gap: "1rem", width: "100%" }}>
              <Typography color="GrayText" sx={{ width: "30%" }}>
                Nationality:
              </Typography>
              <Typography sx={{ width: "70%" }}>
                {personalInfo?.nationality?.name}
              </Typography>
            </Box>
          )}
          {personalInfo?.created_at && (
            <Box sx={{ display: "flex", gap: "1rem", width: "100%" }}>
              <Typography color="GrayText" sx={{ width: "30%" }}>
                Created at:
              </Typography>
              <Typography sx={{ width: "70%" }}>
                {personalInfo?.created_at}
              </Typography>
            </Box>
          )}
        </Grid>
      </Grid>
    </MainCard>
  );
};

export default ViewPersonalInformation;
